// extracted by mini-css-extract-plugin
module.exports = {"arrows":"SliderArrows_arrows__DyvHp","left":"SliderArrows_left__NxUUt","right":"SliderArrows_right__6g297","rotated":"SliderArrows_rotated__1k0wz"};